import { render } from "./ImageViewer.vue?vue&type=template&id=680ffad4&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"

import "./ImageViewer.vue?vue&type=style&index=0&id=680ffad4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-680ffad4"

export default script